import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig(
  {
    name: 'schemametadata',
    cache: {
      ttl: 900000
    }
  })
export class SchemaMetadataStore extends BaseStore {

  constructor() {
    super();
  }
}
